/**
 * True for AbortSignal (and AbortSignal-like objects), false for React SyntheticEvents.
 * Prevents axios/fetch from receiving a FocusEvent/ClickEvent as `signal`.
 */
export function isAbortSignal(value) {
  return Boolean(
    value
    && typeof value === 'object'
    && typeof value.aborted === 'boolean'
  );
}

/** Return signal only when it is a real AbortSignal; otherwise undefined. */
export function asAbortSignal(value) {
  return isAbortSignal(value) ? value : undefined;
}

/**
 * Merge an optional AbortSignal into a request config without poisoning axios/fetch.
 * @param {object} [config]
 * @param {unknown} [signal]
 */
export function withAbortSignal(config = {}, signal) {
  const next = { ...config };
  const safe = asAbortSignal(signal);
  if (safe) {
    next.signal = safe;
  } else {
    delete next.signal;
  }
  return next;
}
